import 'ol/ol.css';
import * as ol from 'ol';
// import * as olLayer from "ol/layer";
// import * as olSource from "ol/source";
import * as olStyle from 'ol/style';
// import * as olProj from 'ol/proj';

import VectorSource from 'ol/source/Vector';
import * as olSource from 'ol/source';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {
  Tile as TileLayer,
  Vector as VectorLayer
} from 'ol/layer';

import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style
} from 'ol/style';

import * as olControl from 'ol/control';
import { defaults as defaultInteractions } from 'ol/interaction';
import { getVuetifyThemeVar } from '@/utils/mapLayerTheme';

/** 사이트 정보 수정 등 소형 맵 전용 — 대시보드 DotMapStyle SVG 핀과 분리 */
const SITE_EDIT_MAP_PIN_SRC = '/img/icons/imagePos.png';

const baseMapUrl = process.env.VUE_APP_GEO_SERVER_URL;

const getThemeVar = getVuetifyThemeVar;

const OpenLayerMap = {
  eventHandler: null, // ScreenSpaceEventHandler cesium 맵에서 이벤트가 발생하면 동작
  missionWaypoints: [],
  eventListeners: new Map(),
  map: undefined,
  vectorLayer: undefined,
  vectorSource: undefined,
  features: [],
  marker: undefined,

  destroyMap() {
    if (this.map) {
      this.map.setTarget(null);
      this.map = undefined;
    }
    this.vectorSource = undefined;
    this.vectorLayer = undefined;
    this.marker = undefined;
  },

  init: function (markerCoords, payload = {}) {

    this.destroyMap();

    this.vectorSource = new VectorSource({
      features: this.features,
      style: function () {
        return new Style({
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: getThemeVar('--v-text-base', '#1A1D26')
            }),
            stroke: new Stroke({
              color: getThemeVar('--v-surface-base', '#FFFFFF'),
              width: 2
            })
          })
        });
      }
    });

    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      style: new olStyle.Style({
        image: new olStyle.Icon({
          anchor: [0.5, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: SITE_EDIT_MAP_PIN_SRC
        })
      })
    });

    this.map = new ol.Map({
      controls: olControl.defaults(),
      interactions: defaultInteractions(),
      target: 'map',
      // layers: [raster],
      view: new ol.View({
        projection: 'EPSG:4326',
        center: markerCoords,
        maxZoom: 18,
        zoom: 12,
        constrainRotation: false  // 🆕 회전 제약 완전 해제
      }),
      layers: [
        new TileLayer({
          source: new olSource.TileWMS({
            // crossOrigin: 'anonymous'
            url: baseMapUrl + '/wms',
            params: {
              'FORMAT': 'image/png',
              'VERSION': '1.1.1',
              'tiled': true,
              'LAYERS': 'solar-plant:Satellite',
              'SRS': 'EPSG:4326',
              'exceptions': 'application/vnd.ogc.se_inimage'
            }
          })
        }),
        this.vectorLayer
      ]
    });

    if (payload.rotation !== undefined && payload.rotation !== null) {
      const rotationInRadians = (Number(payload.rotation) * Math.PI) / 180;
      if (Number.isFinite(rotationInRadians)) {
        this.map.getView().setRotation(rotationInRadians);
      }
    }

    if (markerCoords && payload.init) {
      this.addFeature(markerCoords);
    }
    this.map.on('singleclick', (event) => {
      this.addFeature(event.coordinate);
      // this.map.addLayer(newMarker.layer); // layer를 더한다
      this.fireEvent('set-point', event.coordinate);
    });

    if (typeof payload.onMapReady === 'function') {
      payload.onMapReady(this.map);
    }
  },

  removeFeature(){
    if (this.marker !== undefined) {
      this.vectorSource.removeFeature(this.marker); // 포인터를 하나만 찍기위해 클릭될때마다 이전에 찍은 포인터를 지운다.
    }
  },

  addFeature(coords) {

    if(!this.vectorSource){
      return;
    }

    console.log('markerrrrrrrrrrrrr ', this.marker);

    if (this.marker && this.vectorSource) {
      this.vectorSource.removeFeature(this.marker); // 포인터를 하나만 찍기위해 클릭될때마다 이전에 찍은 포인터를 지운다.
    }

    this.marker = new Feature({
      type: 'marker',
      geometry: new Point(coords)
    });

    this.vectorSource.addFeature(this.marker);
    // var lonlat = new OpenLayers.LonLat(coords[0], coords[1]);
    // this.map.getView().setCenter(coords);
    this.map.getView().animate({
      center: coords,
      duration: 200
    });
  },

  addEventListener(name, listener) {
    if (!this.eventListeners.has(name)) {
      this.eventListeners.set(name, listener);
    }
  },
  // 등록된 이벤트를 제거한다.
  removeEventListener(name) {
    if (this.eventListeners.has(name)) {
      this.eventListeners.delete(name);
    }
  },

  async fireEvent(eventType, payload) {
    if (payload !== undefined) {
      this.eventListeners.forEach((listener, name) => {
        console.log('[' + name + '] event listener called', listener, payload);
        (listener)(eventType, payload);
      });
    }
  }

};

export default OpenLayerMap;
